<template>
	<div>
		<div class="banner">
			<img :src="pageData.banner" alt="">
			<div class="title">{{pageData.title}}</div>
		</div>

		<!-- 内容容器 -->
		<div class="content-wrapper">
			<!--data0产品名称  描述 -->
			<!-- <section class="data0">
        <div class="content">
          <div class="title">{{pageData.data0.title}}</div>
          <div class="detail">{{pageData.data0.desc}}</div>
        </div>
      </section> -->
			<!-- data1 产品优势 -->
			<section class="data0-data1">
				<div class="data0">
					<div class="title">{{pageData.data0.title}}</div>
					<div class="lists">
            <template v-for="(item, index) in pageData.data0.lists" >
              <div :key="index" v-if="index < 9" class="item" @mouseenter="changeServiceIndex(index)" @mouseleave="changeServiceIndex()">
                <img class="" :src="serviceIndex === index ? item.imgUrl2 : item.imgUrl" alt="">
                <!-- <div class="img-box">
                  <img class="bg" v-if="item.status===1" src="./images2/service_icon_bg_nor@2x.png" alt="">
                  <img class="bg" v-if="item.status===2" src="./images2/home_business_sel@2x.png" alt="">
                  <img class="content-img" :src="item.status===1?item.img1:item.img2" alt="">
                </div> -->
                <div class="text">{{item.title}}</div>
              </div>
            </template>
					</div>
				</div>
				<div class="data1">
					<div class="title">{{pageData.data1.title}}</div>
					<div class="lists">
						<div v-for="(item, index) in pageData.data1.lists" :key="index" class="item">
              <div class="overlay-box"></div>
              <img :src="item.imgUrl" alt="" style="display: block">
							<div class="title">{{item.title}}</div>
							<div class="desc">{{item.content}}</div>
						</div>
					</div>
				</div>
			</section>
			<section class="data2">
				<div class="content">
					<img :src="pageData.data2.img" alt="">
					<div class="text-box">
						<div class="title">{{pageData.data2.title}}</div>
						<div class="sub_title">{{pageData.data2.sub_title}}</div>
					</div>
				</div>
			</section>
			<section class="data3">
				<div class="content">
					<div class="title">{{pageData.data3.title}}</div>
					<div class="sub_title">{{pageData.data3.sub_title}}</div>
					<div class="lists">
            <template v-for="(item, index) in pageData.data3.lists">
              <div :key="index" class="item" v-if="index < 5">
                <img :src="icons[index%5]" alt="">
                <div class="title">{{item.info}}</div>
                <!-- <div class="sub_title">{{item.sub_title}}</div> -->
                <div class="desc">{{item.desc}}</div>
                <div class="text2">{{item.text2}}</div>
              </div>
            </template>
					</div>
				</div>
			</section>
			<section class="data4">
				<div class="content">
					<div v-for="(item, index) in pageData.data4" :key="index" class="item" :class="{right: index%2==1&&!['xs'].includes(deviceType)}">
						<div class="img-box">
							<img :src="item.imgUrl" alt="">
						</div>
						<div class="text-box">
							<div class="title">{{item.title}}</div>
							<div class="sub_title">{{item.sub_title}}</div>
              <template>
                <div class="lists">
                  <template v-for="(item, index) in handleBrArr(item.content)">
                    <div class="detail" :key="index" v-if="item">
                      {{item}}
                    </div>
                  </template>
                  <!-- <div v-html="handleBrTag(item.content)"></div> -->
                </div>
              </template>
							<!-- <div class="lists" v-html="handleBrTag(item.content)"> -->
                <!-- <div>{{item.content}}</div> -->
								<!-- <div v-for="(detail, II) in item.lists" :key="II" class="detail">
									<span>{{II + 1}}</span>{{detail}}
								</div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import mixins from '@/mixins';
	import eventBus from '@/utils/eventBus';
  import Swiper from 'swiper';
	import { bannerList, indexDataList, getAppInfo, itemList } from '@/utils/api';

	export default {
    name: '',
    mixins: [mixins],
		props: {},
		data() {
			return {
				screenWidth: 0,
				screenHeight: 0,
				activeNav: 'service',
				pageData: {
					banner: '',
					title: '售后服务网络',
					// 我的服务
					data0: {
						title: '我们的服务',
						lists: [],
					},
					// 各行业；
					data1: {
						title: '专注各种行业',
						lists: [],
					},
					data2: {
						title: '全国服务网点1111',
						sub_title: '标语标语标语标语标语',
						img: '',
					},
					data3: {
						title: '我们的优势',
						sub_title: '标语标语标语标语标语',
						lists: []
					},
					data4: [
						{
							img: '',
							title: '星级服务十项指标',
							sub_title: '标语标语标语标语标语',
							lists: []
						},
						{
							img: '',
							title: '星级服务十项指标',
							sub_title: '标语标语标语标语标语',
							lists: []
						}
					]
				},
				data2Index: 0,
        serviceIndex: 0,
        icons: [
          require('../assets/images2/service_icon_bg_1.png'),
          require('../assets/images2/service_icon_bg_2.png'),
          require('../assets/images2/service_icon_bg_3.png'),
          require('../assets/images2/service_icon_bg_4.png'),
          require('../assets/images2/service_icon_bg_5.png')
        ]
			};
		},
		components: {},
		created() {
      this.init();
			this.$store.commit('activeNav', 'service');
		},
		computed: {
      deviceType() {
        return this.$store.state.deviceType;
      }
		},
		mounted() {
		},
		methods: {
      async init() {
        const res1 = await getAppInfo('key-service-m-title');
        this.pageData.title = res1.data.baseData.content;
        console.log('service--res1==', res1);
        const res1_1 = await getAppInfo('key-service-m-imgUrl');
        this.pageData.banner = res1_1.data.baseData.content;
        console.log('service--res1_1==', res1_1);

        // const res1 = await getAppInfo('key-menu-service-title');
        // this.pageData.title = res1.data.baseData.content;
        // console.log('service--res1==', res1);

        const res2 = await itemList({type: 1});
        this.pageData.data0.lists = res2.data.baseData || [];
        console.log('service--res2==', res2);
        const res2_1 = await getAppInfo('key-service-m-list-title');
        this.pageData.data0.title = res2_1.data.baseData.content;

        const res3 = await itemList({type: 2});
        this.pageData.data1.lists = res3.data.baseData || [];
        console.log('service--res3==', res3);

        const res3_1 = await getAppInfo('key-service-m-idu-title');
        this.pageData.data1.title = res3_1.data.baseData.content;

        const res4 = await itemList({type: 6});
        this.pageData.data4 = res4.data.baseData || [];
        console.log('service--res4==', res4);

        // 我们的优势；
        const res5 = await itemList({type: 3});
        this.pageData.data3.lists = res5.data.baseData || [];
        console.log('service--res5==', res5);
        const res51 = await getAppInfo('key-service-m-advantage-title');
        this.pageData.data3.title = res51.data.baseData.content;
        console.log('service--res51==', res51);
        const res52 = await getAppInfo('key-service-m-advantage-subTitle');
        this.pageData.data3.sub_title = res52.data.baseData.content;
        console.log('service--res52==', res52);

        // 全国服务网点；
        const res6 = await getAppInfo('key-service-m-shop-title');
        this.pageData.data2.title = res6.data.baseData.content;
        console.log('service--res6==', res6);
        const res7 = await getAppInfo('key-service-m-shop-desc');
        this.pageData.data2.sub_title = res7.data.baseData.content;
        console.log('service--res7==', res7);
        const res8 = await getAppInfo('key-service-m-shop-imgUrl');
        this.pageData.data2.img = res8.data.baseData.content;
        console.log('service--res8==', res8);


        this.$set(this, 'pageData', this.pageData);
        console.log('service--this.pageData==', this.pageData);
      },
			changeNav(item) {
				console.log('changeNav--item==', item);
				if (item.id === 'product') {
					// this.showProductMenu = !this.showProductMenu;
					this.showProductMenu = true;
				} else {
					this.showProductMenu = false;
				}
				this.activeNav = item.id;
				// this.$router.push({path: '/pages/product'})
			},
			changeServiceIndex(index) {
				this.serviceIndex = index;
			},
			handleOpen(e) {
				console.log('handleOpen--e==', e);
			},
			handleClose(e) {
				console.log('handleClose--e==', e);
			},
			visibleChange(bool) {
				console.log('visibleChange--bool==', bool);
				this.productList = this.productList.map(d => {
					d.open = false;
					return d;
				})
			},
			switchProduct(item, index) {
				console.log('switchProduct--item==', item);
				console.log('switchProduct--index==', index);
				console.log('switchProduct--this.productList==', this.productList);
				let row = JSON.parse(JSON.stringify(item));
				row.open = item.open ? false : true;
				this.$set(this.productList, index, row)
			},
			selProduct(e) {
				console.log('selProduct--e==', e);
			},
			handleSliceStr(str, start = 0, end) {
				var str1 = JSON.parse(JSON.stringify(str));
				if (!str) {
					return '';
				}
				if (!end || end > str.length) {
					end = str.length;
				}
				return str1.slice(start, end);
			},
			// changeData2Index(num) {
			//   const max = Math.ceil(this.pageData.data2.lists.length / 4);
			//   console.log('changeData2Index--max==', max);

			//   if (num > 0 && this.data2Index < max) {
			//     this.data2Index += num;
			//   } else if (num < 0 && this.data2Index > 0) {
			//     this.data2Index += num;
			//   }
			// }
		}
	};
</script>

<style scoped lang="scss">
	@import "../common/css/service.scss";
</style>


// WEBPACK FOOTER //
// src/pages/service.vue